import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { productGroups } from "../../mock";
import CategorySidebar from "../layout/CategorySidebar";
import { ChevronRight } from "lucide-react";
import { t } from "../../i18n";

const ProductsPage = () => {
    const { lang } = useLanguage();

    return (
        <div className="pt-[115px] sm:pt-[125px] bg-[#f5f5f5] min-h-screen">
            {/* Breadcrumbs */}
            <div className="bg-white border-b border-black/5 py-4 mb-6">
                <div className="w-full max-w-[1900px] mx-auto px-4 sm:px-6 lg:px-8 flex items-center space-x-2 text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold">
                    <Link to="/" className="hover:text-primary flex items-center">
                        {t(lang, "nav.home")}
                    </Link>
                    <ChevronRight size={12} className="text-gray-400" />
                    <span className="text-primary">
                        {t(lang, "nav.products")}
                    </span>
                </div>
            </div>

            <div className="w-full max-w-[1900px] mx-auto px-4 sm:px-6 lg:px-8 pb-12">
                <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
                    {/* Left Sidebar */}
                    <CategorySidebar />

                    {/* Main Content */}
                    <div className="flex-grow">
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
                            {productGroups.map((group) => (
                                <Link
                                    key={group.id}
                                    to={`/products/${group.slug}`}
                                    className="group relative block aspect-square w-full overflow-hidden bg-white rounded-lg border border-gray-100 shadow-[0_3px_10px_rgb(0,0,0,0.06)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300"
                                >
                                    <img
                                        src={group.imageUrl}
                                        alt={group[`title_${lang}`]}
                                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 bg-black/60 backdrop-blur-[2px] py-3 text-center border-t border-white/10 transition-colors group-hover:bg-primary/90">
                                        <h3 className="text-[12px] font-bold tracking-widest text-white uppercase px-2 line-clamp-1">
                                            {group[`title_${lang}`]}
                                        </h3>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductsPage;
